import qs from 'query-string';
import {connect} from 'react-redux';
import {Component} from 'react';

import {discoverPin} from '-/util/authenticate';
import Modal from '-/components/general/Modal';
import {isMobile} from '-/util/util';

const {pin = ''} = qs.parse(location.search);

class Pin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pin
        };
    }

    componentDidMount() {
        if (!isMobile()) {
            this.input.select();
        }
    }

    onPinChange(pin) {
        this.setState({
            pin
        });
    }

    onSubmit() {
        const {discoverPin} = this.props;
        const {pin} = this.state;

        if (!pin) {
            return;
        }

        discoverPin(pin);
    }

    render() {
        const {pinDiscoveryFailure, submittedPin} = this.props;
        const {pin} = this.state;

        return (
            <Modal onClick={() => this.onSubmit()}>
                <section className="description-box">
                    <div className="text">
                        <h1>Enter PIN</h1>
                        {submittedPin && pinDiscoveryFailure && (
                            <h4 className="error-text">
                                {submittedPin} does not match an offer
                            </h4>
                        )}
                    </div>
                </section>

                <div className="masked-form">
                    <div className="control">
                        <input
                            className="account-input pin"
                            type="text"
                            value={pin}
                            ref={ref => (this.input = ref)}
                            placeholder="XXXXXX"
                            maxLength="6"
                            onChange={e => this.onPinChange(e.target.value)}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    const {
        pinDiscoveryFailure = false,
        submittedPin
    } = state.validationInfo;

    return {
        pinDiscoveryFailure,
        submittedPin
    };
};

export default connect(mapStateToProps, {discoverPin})(Pin);
